import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useRecentGenerations, formatRecentGeneration } from "../components/RecentGenerations";

export default function Navbar() {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const recentGenerations = useRecentGenerations();

    const handleLogout = (e) => {
        e.preventDefault();
        logout();
        navigate('/');
    };

    return (
            <div>
                <nav className="main-header navbar navbar-expand navbar-dark">
                    {/* Left navbar links */}
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" data-widget="pushmenu" href="fake_ref" role="button">
                                <i className="fas fa-bars"></i>
                            </a>
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <Link to="/" className="nav-link">Home</Link>
                        </li>
                        {isAuthenticated ? (
                            <>
                                <li className="nav-item d-none d-sm-inline-block">
                                    <Link to="/admin" className="nav-link">Admin</Link>
                                </li>
                                <li className="nav-item d-none d-sm-inline-block">
                                    <Link to="/contact" className="nav-link">Contact</Link>
                                </li>
                                <li className="nav-item d-none d-sm-inline-block">
                                    <Link to="/generate-apk" className="nav-link">Generare APK</Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item d-none d-sm-inline-block">
                                    <Link to="/login" className="nav-link">Login</Link>
                                </li>
                                <li className="nav-item d-none d-sm-inline-block">
                                    <Link to="/sign-up" className="nav-link">Register</Link>
                                </li>
                            </>
                        )}
                    </ul>

                    {/* Right navbar links */}
                    <ul className="navbar-nav ml-auto">
                        {/* Navbar Search */}
                        <li className="nav-item">
                        <a className="nav-link" data-widget="navbar-search" href="fake_ref" role="button">
                        <i className="fas fa-search"></i>
                        </a>
                        <div className="navbar-search-block">
                        <form className="form-inline">
                            <div className="input-group input-group-sm">
                            <input className="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search"/>
                            <div className="input-group-append">
                                <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                                </button>
                                <button className="btn btn-navbar" type="button" data-widget="navbar-search">
                                <i className="fas fa-times"></i>
                                </button>
                            </div>
                            </div>
                        </form>
                        </div>
                    </li>

                    {/* Notificari - ultimele 3 generari APK, de pe toata platforma */}
                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="fake_ref">
                        <i className="far fa-bell"></i>
                        {recentGenerations.length > 0 && (
                            <span className="badge badge-warning navbar-badge">{recentGenerations.length}</span>
                        )}
                        </a>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                        <span className="dropdown-item dropdown-header" style={{fontSize: 13}}>Generări Apk recente</span>
                        <div className="dropdown-divider"></div>
                        {recentGenerations.length === 0 ? (
                            <span className="dropdown-item text-muted">Nicio generare încă.</span>
                        ) : (
                            recentGenerations.map((item, i) => (
                                <React.Fragment key={i}>
                                    <span className="dropdown-item text-wrap" style={{fontSize: 13}}>{formatRecentGeneration(item)}</span>
                                    {i < recentGenerations.length - 1 && <div className="dropdown-divider"></div>}
                                </React.Fragment>
                            ))
                        )}
                        </div>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-widget="fullscreen" href="fake_ref" role="button">
                        <i className="fas fa-expand-arrows-alt"></i>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-widget="control-sidebar" data-slide="true" href="fake_ref" role="button">
                        <i className="fas fa-th-large"></i>
                        </a>
                    </li>
                    {isAuthenticated && (
                        <li className="nav-item">
                            <a className="nav-link" href="/logout" onClick={handleLogout} title="Logout">
                                <i className="fas fa-sign-out-alt"></i>
                            </a>
                        </li>
                    )}
                    </ul>
                </nav>
            </div>
    );
}
